import angular from 'angular';
import importantDatesPopover from './importantDatesPopover';
import pipelineImportantDateModal from './pipelineImportantDateModal/pipelineImportantDateModal';
import './style.scss';

export default angular
  .module('components.importantDatesPopover', [])
  .component('importantDatesPopover', importantDatesPopover)
  .component('pipelineImportantDateModal', pipelineImportantDateModal).name;
